import createRouter5, { Options, Route } from 'router5'
import browserPlugin from 'router5-plugin-browser'
import loggerPlugin from 'router5-plugin-logger'

export function createRouter(
  routes: Route[],
  options: Partial<Options> & { useLogger?: boolean } = {}
) {
  const { useLogger, ...routerOptions } = options
  const router = createRouter5(routes, {
    strictTrailingSlash: false,
    trailingSlashMode: 'never',
    allowNotFound: true,

    ...routerOptions,
  })

  router.usePlugin(browserPlugin({ useHash: false }))

  if (useLogger) {
    router.usePlugin(loggerPlugin)
  }

  return router
}
